import * as React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { PensionProtectionDetails } from "../../../../../../../Wrap/Models/Models/Customer/PensionProtection/PensionProtectionDetails";
import { ITypographySectionProps, Typography } from "../../../../../../Shared/Typography/Typography";
import { GrantedTypes, GrantedTypesMap, PensionProtectionMap } from "../../../ClientRecord/Resource/Contents";

interface IPensionProtectionPlayBackProps {
    data: PensionProtectionDetails;
    hasPensionProtection: boolean;
}
export const PensionProtectionPlayBack = (props: IPensionProtectionPlayBackProps) => {
    let config: ITypographySectionProps[] = [];
    if (!props.data) {return null;}

    const grantSelected = (key: string): string => {
        const _data = props.data[key];
        let flag = null;
        GrantedTypes.forEach((ele) => {
            if (_data[ele]) {flag = ele;}
        });
        return flag;
    };
    PensionProtectionMap.forEach((ele) => {
        if (props.data[ele.key]) {
            config.push({
                title: <b>{ele.value}</b>,
                data: "Yes",
            });
            switch (ele.key) {
                case "PensionEnhancedProtectionDetails":
                    config = config.concat([
                        { title: "PCLS entitlement (%)", data: props.data[ele.key].PclsEntitlement },
                        { title: "Certificate number", data: props.data[ele.key].CertificateNumber },
                    ]);
                    break;
                case "PensionPrimaryProtectionDetails":
                    config = config.concat([
                        { title: "PCLS entitlement (£)", data: props.data[ele.key].PclsEntitlement },
                        { title: "Certificate number", data: props.data[ele.key].CertificateNumber },
                        { title: "Enhancement factor number", data: props.data[ele.key].EnhancementFactor },
                    ]);
                    break;
                case "PensionFixedProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Fixed protection 2012)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                    ]);
                    break;
                case "PensionFixed2014ProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Fixed protection 2014)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                    ]);
                    break;
                case "PensionFixed2016ProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Fixed protection 2016)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                    ]);
                    break;
                case "PensionIndividual2014ProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Individual protection 2014)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                        { title: "Individual Protection 2014 LTA amount", data: props.data[ele.key].Amount },
                    ]);
                    break;
                case "PensionIndividual2016ProtectionDetails":
                    config = config.concat([
                        {
                            title: "Certificate number (Individual protection 2016)",
                            data: props.data[ele.key].CertificateNumber,
                        },
                        { title: "Individual Protection 2016 LTA amount", data: props.data[ele.key].Amount },
                    ]);
                    break;
                case "PensionRelevantOverseasProtectionDetails":
                case "PensionQropsProtectionDetails":
                case "PensionCreditProtectionDetails":
                    config = config.concat([
                        { title: "Certificate number", data: props.data[ele.key].CertificateNumber },
                        { title: "Enhancement factor number", data: props.data[ele.key].EnhancementFactor },
                        { title: "Granted", data: GrantedTypesMap[grantSelected(ele.key)] },
                    ]);
                    break;
                case "PensionSchemeSpecificProtectionDetails":
                    config = config.concat([
                        { title: "Protected PCLS value", data: props.data[ele.key].PclsEntitlement },
                        { title: "ADay fund value", data: props.data[ele.key].ADayFundValue },
                        { title: "Protected retirement age", data: props.data[ele.key].ProtectedRetirementAge },
                    ]);
                    break;
                default:
                    break;
            }
        }
    });
    return (
        <>
            <RadiosEditor
                label="Does your client have any form of pension protection?"
                onChange={(v) => {}}
                getText={(o) => (o ? "Yes" : "No")}
                options={[true, false]}
                cssWrapper="rg-inline mb-20"
                disabled={true}
                selected={props.hasPensionProtection}
            />
            {props.hasPensionProtection && (
                <Accordion label="Pension protection details" cssWrapper="accordion-with-arrow mb-20">
                    <Typography config={config} colNum={1} type={"wider"} />
                </Accordion>
            )}
        </>
    );
};
